// src/icon-system/adapters/boyut.ts — piksel → boyut token'ı (adaptörlerin ve köprülü
// çağrıların ORTAK kuralı). `cozumleyici.ts`ten AYRILDI (Faz C): cozumleyici
// `import * as generated` taşır; yalnız boyut kuralına ihtiyaç duyan eager bir
// dosya (BottomNav `size={28}`) 78 aileyi ilk pakete çekmesin.
import uyum from "../contracts/uyumluluk.json";
import type { IkonBoyut } from "../runtime/IconFrame";

export interface BoyutCozumu {
  boyut?: IkonBoyut;
  /** Token dışı px kutusu — ADLI prop (2026-09-14). Eskiden `style` ile
   *  geçiyordu ve `IconFrame` içinde merkezi kutuyu EZİYORDU; artık kutu
   *  kararı tek yerde (IconFrame) ve `style` ölçüyü değiştiremez. */
  kutuPx?: number;
  /** Token dışı px (18/22/28…): px korunur, borç `data-boyut-px` ile GÖRÜNÜR. */
  borc?: number;
}

/** Piksel → boyut token'ı; token dışı (18/22/28…) px olarak KORUNUR (görsel parite), `data-boyut-px` ile borç görünür. */
/* ── `kutuPx` İSTİSNALARI — NEREDE, NİYE (owner, 2026-09-14: *"`kutuPx`
   istisnalarının nerede ve neden gerektiğini açık tut."*) ────────────────
   Kutu ölçüsü normalde KADEME TOKEN'ıdır (16/20/24/32 → `--ikon-boyut-*`).
   `kutuPx` yalnız o kademelerde KARŞILIĞI OLMAYAN bir piksel gerektiğinde
   doğar ve borç `data-boyut-px` ile DOM'da GÖRÜNÜR kalır. Bugünkü liste
   (2026-09-14 ölçümü, `grep "kutuPx: _b"`):
     13/14/15/26 px — `NewPost.tsx`      (composer satır-içi işaretleri)
     18/22 px       — `ClipsDesktop.tsx` · `MyClips.tsx`
     28 px          — `Post.tsx` · `ClipInFeed.tsx` (kart kebab/başlık ölçüsü,
                      owner talimatıyla KORUNDU — #18'de ölçülmüştü)
     26 px          — `BottomNav.tsx` (yalnız `data-boyut-px` borcu için;
                      KUTU token'dan gelir → `kutuOlcu`)
   ⚠️ Token DIŞI ölçü bir BORÇTUR: azaltmak istendiğinde bu liste kısalır.
   Ölçü token'a ya da orana (`kutuOlcu`: `var(--…)`, `1em`, `100%`) bağlıysa
   `kutuPx` KULLANILMAZ. */
export function boyutCoz(size: number | undefined): BoyutCozumu {
  if (size === undefined) return {};
  const tok = (uyum.boyutTokenlari as Record<string, string | undefined>)[String(size)];
  if (tok) return { boyut: tok as IkonBoyut };
  return { kutuPx: size, borc: size };
}

/** `boyutCoz`un köprü-props hâli. */
export interface BoyutPropsu {
  boyut?: IkonBoyut;
  kutuPx?: number;
  "data-boyut-px"?: number;
}

/**
 * `<IkonKoprusu {...boyutPropsu(size)} …/>` — DİNAMİK `size` taşıyan çağrı yerleri için.
 *
 * NİYE AYRI BİR YARDIMCI (ölçüldü): bugüne kadarki desen (BottomNav `size={28}`,
 * NewPost `MOTOR_BOYUT_13`…) bu üç satırı ÜRÜN dosyasına yazıyordu. Köprü-söküm
 * sondası (`ikonDalga*Sozlesmesi`) yalnız `<IkonKoprusu/>` düğümünü geri koyar;
 * ürün dosyasına eklenen modül-seviye sabit ya da `const b = boyutCoz(size)`
 * satırı sökümden SONRA ayakta kalır → kaynak tabana bayt-birebir DÖNMEZ ve
 * "bayrak kapalı kolda delta 0" iddiası ölçülemez hâle gelir. Yardımcı burada
 * (icon-system) durunca ürün dosyasına düşen tek fazlalık `import` satırıdır ve
 * o satır sondada normalize edilir.
 *
 * Token dışı px (12/13/18/22/28…) KORUNUR ve borç `data-boyut-px` ile DOM'da
 * GÖRÜNÜR kalır — token'a çekmek owner önizlemesi ister.
 */
export function boyutPropsu(size: number | undefined): BoyutPropsu {
  const b = boyutCoz(size);
  return { boyut: b.boyut, kutuPx: b.kutuPx, "data-boyut-px": b.borc };
}
